export default "__VITE_ASSET__88c8eec7__"